module.exports = __webpack_public_path__ + "img/seller3.cfde273c.png";